import * as cases from '../../../apis/case'
import { createSelector } from 'reselect'
import * as cookies from '../../../utilties/cookies'
import { stopSaving } from '../../actions'

const REFRESH_CURRENT_CASE_REQUESTED = 'REFRESH_CURRENT_CASE_REQUESTED'

export const refreshCurrentCase = () => (dispatch, getState) => {
	var state = getState()

    let selectedCaseCookie = cookies.get('selectedCase');

	if(selectedCaseCookie && state.cases.cases)
	{
		if(state.cases.cases.id == selectedCaseCookie)
		{
			return dispatch({ type: REFRESH_CURRENT_CASE_REQUESTED, 
			data: { 
				id: state.cases.cases.id, 
				protocolName: state.cases.cases.protocolName 
			}});			
		}
	}
}

const SET_CURRENT_CASE_REQUESTED = 'SET_CURRENT_CASE_REQUESTED'
const SET_CURRENT_CASE_FAILED = 'SET_CURRENT_CASE_FAILED'
export const setCurrentCase = (caseId) => (dispatch) => {

	dispatch({ type: FETCH_CASES_REQUESTED, data: {} })
	let patient = cookies.get('user')
    return cases.setSelectedCase(caseId).then((response) => {
        if (response) {
			window.location.href = patient && patient.externalAuth ? '/scores' : '/'
		} else if(!response || !response.redirectTo) {
            dispatch({
                type: 'SET_CURRENT_CASE_FAILED',
                data: {
                    message: 'app.case.failedChangeSelectedCase',
                    isSuccess: false
                }
            })
        }
    })    
}

const FETCH_CASE_REQUESTED = 'FETCH_CASE_REQUESTED'
const FETCH_CASE_SUCCESS = 'FETCH_CASE_SUCCESS'
const FETCH_CASE_FAILED = 'FETCH_CASE_FAILED'

export const getCase = (id, caseId) => (dispatch) => {
	dispatch({ type: FETCH_CASE_REQUESTED, data: {} })
	return cases.fetchCase(id, caseId).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_CASE_SUCCESS, data: response })
		} else if(!response || !response.redirectTo) {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.case.failedGetCase',
					isSuccess: false
				}
			})
		}
	})
}

const FETCH_CASES_REQUESTED = 'FETCH_CASES_REQUESTED'
const FETCH_CASES_SUCCESS = 'FETCH_CASES_SUCCESS'
const FETCH_CASES_FAILED = 'FETCH_CASES_FAILED'

export const getCases = () => (dispatch) => {

    dispatch({ type: FETCH_CASES_REQUESTED, data: {} })

    return cases.fetchCases().then((response) => {
        if (response && response.isSuccessful) {
            return dispatch({ type: FETCH_CASES_SUCCESS, data: response.cases })
		} else if(!response || !response.redirectTo) {
            dispatch({
                type: 'SET_SNACKBAR_MESSAGE',
                data: {
                    message: 'app.case.failedGetCase',
                    isSuccess: false
                }
            })
        }
    })
}

const SUBMIT_SURVEY_ANSWER_REQUESTED = 'SUBMIT_SURVEY_ANSWER_REQUESTED'
const SUBMIT_SURVEY_ANSWER_SUCCESS = 'SUBMIT_SURVEY_ANSWER_SUCCESS'
const SUBMIT_SURVEY_ANSWER_FAILED = 'SUBMIT_SURVEY_ANSWER_FAILED'

export const submitSurvey = (caseId, protocolId, instanceId, surveyId, questionAnswers) => (dispatch, getState) => {
	dispatch({ type: SUBMIT_SURVEY_ANSWER_REQUESTED, data: { isLoading: true } })
	const state = getState()

	let protocol = state.protocol

	let patientCaseSurveyInstances = protocol.patientCaseSurveyInstances

	let questionAnswerSides = []

	Object.keys(patientCaseSurveyInstances).map(key => {
		questionAnswerSides.push({
			questionAnswers: questionAnswers[parseInt(key)],
			patientCaseSurveyInstanceId: patientCaseSurveyInstances[key].patientCaseSurveyInstanceId,
			bilateralAreaId: patientCaseSurveyInstances[key].bilateralAreaId,
			patientCaseSurveyInstanceVersion: patientCaseSurveyInstances[key].patientCaseSurveyInstanceVersion
		})
	})
	
	cases.submitSurvey(caseId, protocolId, instanceId, surveyId, questionAnswerSides).then((response) => {
		dispatch(stopSaving())
		if (response && response.isSuccessful) {
			dispatch({
				type: SUBMIT_SURVEY_ANSWER_SUCCESS,
				data: {
					isSubmitted: true,
					caseId: parseInt(caseId),
					protocolId: parseInt(protocolId),
					surveyId: response.surveyId,
					surveyInstanceId: response.surveyInstanceId,
					isLoading: false,
					referenceDescription: response.referenceDescription,
					pathologyDescription: response.pathologyDescription
				}
			})

			window.scrollTo(0, 0)
		} else if(!response || !response.redirectTo) {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.survey.saveSurveyFailed',
					isSuccess: false
				}
			})
			fetch(`/api/utility/log`, {
				method: 'post',
				headers: {
					'Content-Type': 'application/json',
					'utility-log-location': window.location.href
				},
				body:
				JSON.stringify({
					message: 
						'Submit survey Error\n' +
						'Survey Url: ' + window.location.href + '\n' +
						'Response: ' + JSON.stringify(response) + '\n',
					priority: 3
				})
			})
		}
	})
}

const FETCH_CASE_IMAGES_REQUESTED = 'FETCH_CASE_IMAGES_REQUESTED'
const FETCH_CASE_IMAGES_SUCCESS = 'FETCH_CASE_IMAGES_SUCCESS'
const FETCH_CASE_IMAGES_FAILED = 'FETCH_CASE_IMAGES_FAILED'

export const getCaseImages = (id) => (dispatch) => {
	dispatch({ type: FETCH_CASE_IMAGES_REQUESTED, data: {} })
	return cases.fetchCaseImages(id).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_CASE_IMAGES_SUCCESS, data: response })
		} else if(!response || !response.redirectTo) {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.case.failedGetCaseImages',
					isSuccess: false
				}
			})
		}
	})
}

const MARK_IMAGE_AS_READ_REQUESTED = 'MARK_IMAGE_AS_READ_REQUESTED'
const MARK_IMAGE_AS_READ_SUCCESS = 'MARK_IMAGE_AS_READ_SUCCESS'
const MARK_IMAGE_AS_READ_FAILED = 'MARK_IMAGE_AS_READ_FAILED'

export const markImageAsRead = (id) => (dispatch) => {
	dispatch({ type: MARK_IMAGE_AS_READ_REQUESTED, data: {} })
	return cases.markImageAsRead(id).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: MARK_IMAGE_AS_READ_SUCCESS, data: response })
		} else if(!response || !response.redirectTo) {
			dispatch({
				type: MARK_IMAGE_AS_READ_FAILED,
				data: {}
			})
		}
	})
}

const GO_TO_IMAGE_VIEW_REQUESTED = 'GO_TO_IMAGE_VIEW_REQUESTED'
export const goToImageView = (albumId) => (dispatch) => {
	return dispatch({ type: GO_TO_IMAGE_VIEW_REQUESTED, data: {albumId} })
}

const GO_TO_ALBUM_VIEW_REQUESTED = 'GO_TO_ALBUM_VIEW_REQUESTED'
export const goToAlbumView = () => (dispatch, getState) => {
	return dispatch({ type: GO_TO_ALBUM_VIEW_REQUESTED, data: {} })
}

const initial = {
    currentCase: null,
    cases: null,
	casesList: [],
	answers: null,
	isSubmitted: null,
    nextSurvey: {
		caseId: null,
		protocolId: null,
		surveyId: null,
		instanceId: null
	},
	referenceDescription: null,
	pathology: {
		name: null,
		description: null,
		imageUrl: null
	},
	treatment: {
		name: null,
		description: null,
		imageUrl: null
	},
	isLoading: false,
	caseImages: null,
	showImages: false,
	currentAlbumId: 0
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case REFRESH_CURRENT_CASE_REQUESTED:
			return {
				...state,
                currentCase: action.data
			}
		case SET_CURRENT_CASE_REQUESTED:
            return {
                ...state,
                currentCase: action.data
            }
        case FETCH_CASES_SUCCESS:
			return {
				...state,
                casesList: action.data
			}
		case FETCH_CASE_SUCCESS:
			return {
				...state,
				cases: action.data,
				nextSurvey: {
					caseId: action.data.id,
					protocolId: action.data.protocolId,
					surveyId: action.data.nextSurveyId,
					instanceId: action.data.nextSurveyInstanceId
				},
				referenceDescription: action.data.referenceDescription,
				pathology: {
					name: action.data.pathologyName,
					description: action.data.pathologyDescription,
					imageUrl: action.data.pathologyImageUrl
				},
				treatment: {
					name: action.data.treatmentName,
					description: action.data.treatmentDescription,
					imageUrl: action.data.treatmentImageUrl
				}
			}
		case SUBMIT_SURVEY_ANSWER_SUCCESS:
			return {
				...state,
				isSubmitted: action.data.isSubmitted,
				nextSurvey: {
					caseId: action.data.caseId,
					protocolId: action.data.protocolId,
					surveyId: action.data.surveyId,
					surveyInstanceId: action.data.surveyInstanceId
				}
			}
		case SUBMIT_SURVEY_ANSWER_REQUESTED:
			return {
				...state,
				isSubmitted: false
			}
		case FETCH_CASE_IMAGES_SUCCESS:
			return {
				...state,
				caseImages: action.data
			}
		case GO_TO_IMAGE_VIEW_REQUESTED:
			return { ...state, showImages:  true, currentAlbumId: action.data.albumId }
		case GO_TO_ALBUM_VIEW_REQUESTED:
			return { ...state, showImages:  false, currentAlbumId: 0 }
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.cases

export const caseSelector = createSelector(mainSelector, (state) => {
	if (state && state.cases) return state.cases

	return null
})


export const caseIdSelector = createSelector(mainSelector, (state) => {
	if (state && state.cases) return state.cases.id

	return null
})

export const casesListSelector = createSelector(mainSelector, (state) => {
	if (state && state.casesList) return state.casesList

    return [];
})

export const protocolIdSelector = createSelector(mainSelector, (state) => {
	if (state && state.cases) return state.cases.protocolId

	return null
})

export const circleIdSelector = createSelector(mainSelector, (state) => {
	return state && state.cases && state.cases.sponsorId
})

export const hidePatientResultsSelector = createSelector(mainSelector, (state) => {
	return state && state.cases && state.cases.hidePatientResults
})

export const nextSurveySelector = createSelector(mainSelector, (state) => {
	if (
		state &&
		state.nextSurvey &&
		state.nextSurvey.caseId &&
		state.nextSurvey.protocolId &&
		state.nextSurvey.instanceId &&
		state.nextSurvey.instanceId > 0 &&
		state.nextSurvey.surveyId &&
		state.nextSurvey.surveyId > 0
	)
		return state.nextSurvey

	return null
})

export const nextSurveyMayBeEmptySelector = createSelector(mainSelector, (state) => {
	if (state && state.nextSurvey)
		return state.nextSurvey

	return null
})

export const existCaseSelector = (state) => {
	if (state && state.cases && state.cases.cases) return true
	return false
}

export const isSubmittingSurvey = createSelector(mainSelector, (state) => {
	return state && state.isLoading
})

export const referencesSelector = createSelector(mainSelector, (state) => {
	return state && state.referenceDescription
})

export const pathologySelector = createSelector(mainSelector, (state) => {
	return state && state.pathology
})

export const treatmentSelector = createSelector(mainSelector, (state) => {
	return state && state.treatment
})

export const currentCaseSelector = createSelector(mainSelector, (state) => {
	return state && state.currentCase
})

export const caseImagesSelector = createSelector(mainSelector, (state) => {
	return state && state.caseImages
})

export const showImagesSelector = createSelector(mainSelector, (state) => {
	return state.showImages
})

export const currentAlbumSelector = createSelector(mainSelector, (state) => {
	if (state.caseImages && state.caseImages.albums && state.currentAlbumId) {
		var album = state.caseImages.albums.find(x => x.id === state.currentAlbumId)
		return album
	}

	return null
})

export const surveySavedSelector = createSelector(mainSelector, (state) => {
	return state.isSubmitted
})